module.exports = __webpack_public_path__ + "static/media/icon-sucursal.7e21b370.svg";